// export const endpointBE: string = "http://localhost:5000";
export const endpointBE: string = "https://api.minhhiep2534.id.vn";
// export const endpointBE: string = "https://666d5c8ba84b4a56799dd7ae75760df6.serveo.net";
// fix fe 